import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import axiosInstance from "../../utils/axios-instance";
import CustomToolTip from "./custom-tool-tip";
import UseGraph from "../../utils/use-graph";
import formQueryUrl from "../../utils/form-query-url";

// Compact currency for the card header (£218.2K, £13.3M)
function formatCompact(value: number) {
  if (value >= 1_000_000) return `£${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `£${(value / 1_000).toFixed(1)}K`;
  return `£${value.toFixed(0)}`;
}

export default function MixBarChartData() {
  const [data, setData] = useState([]);
  const { startDate, endDate, isRestarted } = UseGraph();

  const periodTotal = data.reduce(
    (sum, entry) => sum + (Number(entry?.totalCollection) || 0),
    0,
  );

  useEffect(() => {
    const GetData = async () => {
      try {
        const filtersArray = [
          isRestarted && { "restarted-logs": true },
          startDate !== null && { startDate },
          endDate !== null && { endDate },
        ];
        const res = await axiosInstance.get(
          `/stats/moment/payment-track${formQueryUrl(filtersArray, "?")}`,
        );
        setData(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    GetData();
  }, [startDate, endDate, isRestarted]);

  return (
    <div className="flex flex-col w-full h-full min-h-[400px] rounded-2xl border border-edge shadow-card px-6 py-5 bg-surface">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-[19px] text-heading-color font-semibold tracking-tight">
            Movement{" "}
          </h1>
          <p className="text-[13px] text-light-gray font-medium mt-1">
            Collections per day
          </p>
        </div>
        <div className="text-right shrink-0">
          <p className="text-[19px] text-heading-color font-bold tracking-tight tabular-nums">
            {formatCompact(periodTotal)}
          </p>
          <p className="text-[13px] text-light-gray font-medium mt-1">
            in period
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 mt-4">
        <span className="w-2.5 h-2.5 rounded-full bg-accent" />
        <span className="text-[13px] text-light-gray font-medium">
          Collections
        </span>
      </div>

      <div className="flex-1 min-h-[260px] mt-3">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 8,
              right: 8,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid
              vertical={false}
              stroke="var(--color-border-edge)"
              strokeDasharray="4 4"
            />
            <Tooltip
              cursor={{ fill: "var(--color-active-background)", radius: 8 }}
              content={(props) => <CustomToolTip prop={props} data={data} />}
            />

            <Bar
              dataKey="totalCollection"
              stackId="a"
              fill="#6366F1"
              radius={[8, 8, 0, 0]}
              maxBarSize={26}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
